import InnerPartnershipUsersTable from './InnerPartnershipUsersTable';

export default InnerPartnershipUsersTable;
